import {FC} from 'react'
import {useParams} from 'react-router-dom'
import {EntityActivityLogs} from '@/features/entity-activity-logs/components/entity-activity-logs/EntityActivityLogs'

export const PatientActivityLogs: FC = () => {
    const {id} = useParams<{id: string}>()
    return <EntityActivityLogs entityType="patients" entityId={id} />
}
